export default __webpack_public_path__ + "static/media/024-graduate.49fcc569.png";